<template>
  <nav
    v-if="isMobile"
    class="burger-menu"
    :class="{
      'burger-menu--open': isBurgerMenuOpen
    }"
  >
    <span
      href="#"
      name="burger-menu"
      class="burger-menu__close-button"
      @click.prevent="closeButtonClick"
      role="button"
      :aria-label="$t('global.close.button.aria.label')"
      tabindex="0"
      @keydown="handleKeyDown"
    />
    <div class="burger-menu__nav-wrapper">
      <burger-nav-tree
        class="burger-menu__navtree"
        :categories="shopCategoriesTree"
      />
      <header-meta-content
        class="burger-menu__meta-content"
      />
    </div>
  </nav>
</template>

<script>
  import pigeon from '../../utilities/js/pigeon/pigeon.js';
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import BurgerNavTree from '../burgerNavTree/burgerNavTree.vue';
  import { breakpoints } from '../../variables/variables.js';
  import HeaderMetaContent from "../headerMetaContent/headerMetaContent";

  export default {
    mixins: [
      globalStateComputedMixin
    ],
    components: {
      BurgerNavTree,
      HeaderMetaContent
    },
    data() {
      return {
        navMinHeight: 0,
        isMobile: window.innerWidth <= breakpoints.laptop
      };
    },
    mounted() {
      pigeon.subscribe('burgernavtree:levelchange', this.navTreeLevelChangeHandler.bind(this));
    },
    methods: {
      navTreeLevelChangeHandler() {
        this.$el.scrollTop = 0;
      },
      closeButtonClick() {
        this.$store.dispatch('toggleBurgerMenu');
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    }
  };

</script>
